// GENERATED by scripts/release/gen-trust.mjs from release/gacpro-trust.json. Do not edit.
// The published trust config (https://gacpro.io/.well-known/gacpro-trust.json): the GAC Pro signer identity customers pin and the
// pinned runner release. Runners use it as their built-in default; flags / env override it.
export const GACPRO_TRUST = {
    "schema": "gacpro/trust@1",
    "published_at": "https://gacpro.io/.well-known/gacpro-trust.json",
    "signer": {
        "production": {
            "kind": "gcp_service_account_wif",
            "identity": "gacpro-signer-prod@gacpro-signer.iam.gserviceaccount.com",
            "issuer": "https://accounts.google.com",
            "status": "published"
        },
        "non_production": {
            "kind": "gcp_service_account_wif",
            "identity": "gacpro-signer-staging@gacpro-signer.iam.gserviceaccount.com",
            "issuer": "https://accounts.google.com",
            "label": "NON-PRODUCTION (dev / staging only). Never pin this identity for a production run."
        }
    },
    "runner": {
        "version": "0.2.0",
        "release_tag": "gac-action-v0.2.0",
        "archive_url": "https://github.com/channelmatter/gacpro-runner/releases/download/gac-action-v0.2.0/gacpro-runner-0.2.0.tgz",
        "archive_sha256": "c567fc9cf7da7328614d08b19333b14532093c324351c7ad4cc90ab214e2292c",
        "image": "ghcr.io/channelmatter/gacpro-runner",
        "image_digest": "sha256:ce3530d22f1e93cd5e82731b2079a816a0f3b43e5e1fc9945e578929292ac32b",
        "release_manifest_url": "https://github.com/channelmatter/gacpro-runner/releases/download/gac-action-v0.2.0/gacpro-release.json",
        "provenance": "Releases are published only by .github/workflows/gac-action-release.yml to https://github.com/channelmatter/gacpro-runner/releases (no source there). Every archive, manifest, SHA256SUMS and SLSA provenance statement (provenance.intoto.json) carries a keyless Sigstore bundle (<file>.sigstore.json); the image is cosign-signed with the same provenance attached. Check with: cosign verify-blob --bundle <file>.sigstore.json --certificate-identity-regexp \"^https://github.com/channelmatter/FedSec/\\.github/workflows/gac-action-release\\.yml@refs/tags/gac-action-v[0-9]+\\.[0-9]+\\.[0-9]+$\" --certificate-oidc-issuer https://token.actions.githubusercontent.com <file> (images: cosign verify / cosign verify-attestation --type slsaprovenance1, same flags)"
    },
    "cli": {
        "npm": {
            "name": "@gacpro/cli",
            "version": "0.2.1",
            "integrity": "sha512-nd0X+jA4fxq6k8pFgbZfxmd2jLuK8HPpNR15CXlF458ymaKwHgxMEna5dCfuioHhEa7sdBfgQbKIxVi0z+erZQ==",
            "release_url": "https://github.com/channelmatter/gacpro-runner/releases/download/cli-v0.2.1/",
            "cli_sha256": "8d28b238579076c4db6e041dedf45a8f3376f246ea0e34ab30020d72bd8ada3f",
            "certificate_identity_regexp": "^https://github\\.com/channelmatter/FedSec/\\.github/workflows/cli-release\\.yml@refs/tags/cli-v[0-9]+\\.[0-9]+\\.[0-9]+$",
            "certificate_oidc_issuer": "https://token.actions.githubusercontent.com"
        }
    },
    "action": {
        "repo": "gacpro-io/gac-action",
        "version": "0.2.1",
        "commit_sha": "eb3bb0336d9366d22e8d14c95ed84ecf4fa3ca92"
    }
};
//# sourceMappingURL=trust.generated.js.map